import { useMemo } from "react";
import { useAppData } from "../../contexts/AppContext";

/**
 * Resolve o NOME de um tipo de certidão pelo slug, com o mesmo catálogo que monta o submenu da
 * sidebar — é o que garante que trilha, título e menu digam a mesma coisa.
 *
 * Existe como hook compartilhado porque a trilha (faixa global) e o cabeçalho da página precisam
 * exatamente da mesma resolução. O bloco vivia copiado nos dois: mudar a regra em um e esquecer o
 * outro faria título e caminho divergirem na mesma tela.
 *
 * `catalogoCarregado` vem junto de propósito. Sem ele, "o catálogo ainda não chegou" e "este
 * produto não existe no catálogo" viram o mesmo caso, e a tela afirma "Visão Geral" (nenhum produto
 * escolhido) numa URL que pede um produto. Medido no navegador com o catálogo segurado por 4s: a
 * trilha dizia "Gerenciador de Certidões / Visão Geral" por ~6 segundos numa URL `?type=cnd`.
 */
export const useCertificateName = () => {
  const { certificates, certificatesLoaded } = useAppData();

  const certificateName = useMemo(() => {
    const bySlug = new Map((certificates ?? []).map((certificate) => [certificate.slug, certificate.name]));
    return (slug: string) => bySlug.get(slug);
  }, [certificates]);

  return { certificateName, catalogoCarregado: Boolean(certificatesLoaded) };
};
